import { createPortal } from "react-dom";
import useElementWhenReady from "../../hooks/useElementWhenReady";
import ReleaseDateBanner from "../../components/releaseDateBanner/ReleaseDateBanner";

const ReleaseDateBannerPortal = () => {
  const portalElement = useElementWhenReady("#release-date-banner-portal");

  if (!portalElement) {
    return null;
  }

  return createPortal(
    <ReleaseDateBanner className="partOfProductGallery" />,
    portalElement,
  );
};

export default ReleaseDateBannerPortal;
